export enum MODELING_DEPLOY_STATUS {
  DEPLOYING = 'Deploying',
  DEPLOYED = 'Deployed',
  DEPLOY_PENDING = 'DeployPending',
  DEPLOY_FAILURE = 'DeployFailure',
}

export enum MODELING_STATUS {
  Pending = 'Pending',
  Training = 'Training',
  Failure = 'Failure',
  Completed = 'Completed',
}

export const MODELING_ROUTE_PATH = '/modeling';
export const MODELING_TRAINING_ROUTE_PATH =
  `${MODELING_ROUTE_PATH}/training` as const;
